import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlComponent } from './control/control.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BaseComponent } from './base/base.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule  } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [ControlComponent,  BaseComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  providers: [
    //{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  exports: [ControlComponent]
})
export class CommonControlModule { }
